import { Stack, useTheme } from "@mui/system";
import { ReactNode } from "react";
import ViewNumberFormat from "@/views/elements/Inputs/ViewNumberFormat";
import TypographyElement from "@/views/elements/typography/TypographyElement";

type UserAchievementProps = {
    achivements: Array<{title: string, value?: any, render?: ReactNode}>
}

const UserAchievement = ({ achivements }: UserAchievementProps) => {
    const theme = useTheme()

    return <Stack sx={{ flex: 7, paddingLeft: '50px', borderLeft: `1px solid ${theme.palette.border}` }}>
        <Stack direction={'row'} justifyContent={'space-around'} marginTop='-20px' sx={{ flexWrap: 'wrap', height: 'fit-content' }}>
            {achivements.map((achivement, idx) => (
                <Stack key={idx} direction={"column"} sx={{
                    flexBasis: '20%',
                    marginTop: '20px',
                    paddingRight: '20px'
                }}>
                    <TypographyElement ColorElement='secondary' FontSizeElement="14px" FontWeightElement={400}>{achivement.title}</TypographyElement>
                    <TypographyElement ColorElement='primary' FontSizeElement="14px" FontWeightElement={500}>{achivement.render ? achivement.render : <ViewNumberFormat fontWeightElement={500} color="primary" value={Number(achivement.value).toFixed(2) || 0} />}</TypographyElement>
                </Stack>
            ))}
        </Stack>
    </Stack>
};

export default UserAchievement;
